/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TvWallLooping.vue?vue&type=template&id=72a7c264&scoped=true&"
import script from "./TvWallLooping.vue?vue&type=script&lang=js&"
export * from "./TvWallLooping.vue?vue&type=script&lang=js&"
import style0 from "./TvWallLooping.vue?vue&type=style&index=0&id=72a7c264&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a7c264",
  null
  
)

export default component.exports